export default {
  "app": {
    "title": "VisSynth - AI Short Video Generator"
  },
  "common": {
    "apply": "Apply",
    "back": "Back",
    "cancel": "Cancel",
    "close": "Close",
    "closeDialog": "Close",
    "confirm": "Confirm",
    "error": "Error",
    "help": "Help",
    "loading": "Loading...",
    "pricing": "Pricing",
    "product": "Product",
    "reset": "Reset",
    "save": "Save",
    "startCreating": "Start Creating",
    "startNow": "Start Now",
    "viewTutorial": "View Tutorial"
  },
  "history": {
    "tasks": {
      "delete": {
        "error": "Failed to delete task"
      },
      "empty": "No tasks found",
      "loadError": "Failed to load tasks",
      "status": {
        "completed": "Completed",
        "failed": "Failed",
        "pending": "Pending",
        "processing": "Processing"
      },
      "total_one": "{{count}} task",
      "total_other": "{{count}} tasks"
    }
  },
  "home": {
    "description": "Create amazing videos with AI",
    "features": {
      "tools": {
        "description": "Powerful editing tools",
        "title": "Advanced Tools"
      },
      "videoAnalysis": {
        "description": "Analyze videos automatically",
        "title": "Video Analysis"
      },
      "videoProduction": {
        "description": "Produce professional videos",
        "title": "AI Workflows"
      }
    },
    "welcome": "Welcome to VisSynth"
  },
  "imageGeneration": {
    "title": "Image Generation",
    "underDevelopment": "This feature is under development"
  },
  "inputBar": {
    "generating": "Generating...",
    "imageConfig": {
      "hd": "HD",
      "loading": "Loading...",
      "quality": "Quality",
      "resolution": "Resolution",
      "standard": "Standard",
      "title": "Image Settings"
    },
    "placeholder": "Sample: Tom and Jerry: High School Havoc, cartoon, 5 scenes",
    "productionPlaceholder": "Enter video script...",
    "analysisPlaceholder": "Enter video analysis request...",
    "startEmptyScript": "Create Blank Script",
    "startVideo": "Generate Video",
    "title": "Input your idea to generate video",
    "voiceConfig": {
      "loading": "Loading...",
      "title": "Voice Settings",
      "voice": "Voice",
      "speed": "Speed"
    },
    "bgMusic": {
      "title": "Background Music",
      "loading": "Loading...",
      "volume": "Volume"
    },
    "subtitle": {
      "title": "Subtitle Template",
      "default": "Default Template"
    }
  },
  "passwordReset": {
    "email": "Email",
    "platformDescription": "AI-powered short video generator",
    "sendResetEmail": "Send Reset Email",
    "resetPassword": "Reset Password",
    "newPassword": "New Password",
    "confirmPassword": "Confirm New Password",
    "backToLogin": "Remember your password?",
    "login": "Login",
    "sendingEmail": "Sending email...",
    "resettingPassword": "Resetting password...",
    "success": {
      "emailSent": "Password reset email has been sent. Please check your inbox.",
      "passwordReset": "Password reset successfully! Redirecting to login page..."
    },
    "error": {
      "invalidEmail": "Please enter a valid email address.",
      "failedToSendEmail": "Failed to send reset email. Please try again later.",
      "invalidResetLink": "Invalid or expired reset link. Please request a new one.",
      "passwordTooShort": "Password must be at least 6 characters.",
      "passwordsDoNotMatch": "Passwords do not match.",
      "failedToResetPassword": "Failed to reset password. Please try again later."
    }
  },
  "login": {
    "email": "Email",
    "error": {
      "googleLoginFailed": "Google login failed",
      "invalidCredentials": "Invalid email or password"
    },
    "forgotPassword": "Forgot password?",
    "login": "Login",
    "logout": {
      "success": "Logged out successfully"
    },
    "noAccount": "Don't have an account?",
    "orContinueWith": "Or continue with",
    "password": "Password",
    "platformDescription": "AI Visual Synthesis Platform: Powering Your Creativity",
    "signingIn": "Signing in...",
    "signup": "Sign up"
  },
  "payment": {
    "failure": {
      "message": "Sorry, there was a problem with your payment. Please check your payment information and try again.",
      "title": "Payment Failed"
    },
    "success": {
      "message": "Your payment has been successfully completed! Thank you for your support.",
      "title": "Payment Successful"
    },
    "actions": {
      "backToMembership": "Back to Membership"
    },
    "paypal": {
      "subscribeTo": "Subscribe to",
      "secureFastPayment": "Secure and fast overseas payment method",
      "payWithPayPal": "Pay with PayPal",
      "afterPaymentRedirect": "After clicking pay, you will be redirected to PayPal to complete the payment",
      "processingPayment": "Processing payment...",
      "paymentInProgress": "Payment in progress, please complete PayPal payment",
      "processing": "Processing..."
    }
  },
  "membership": {
    "autoRenewal": "Auto-renewal",
    "autoRenewalConvenient": "Convenient, no need to worry about expiration",
    "choosePlan": "Choose Plan",
    "credits": "Credits",
    "currentBenefits": "Current Benefits",
    "currentPlan": "Current Plan",
    "currentStatus": "Current Status",
    "daysRemaining": "Days Remaining",
    "disabled": "Disabled",
    "enabled": "Enabled",
    "expired": "Expired",
    "getPlan": "Get Plan",
    "highestMembership": "Highest Membership Level",
    "loadingStatus": "Loading membership status...",
    "manualRenewalFlexible": "Flexible, renew when needed",
    "member": "Member",
    "monthly": "Monthly",
    "monthlyRemaining": "Monthly Remaining",
    "noMembership": "No Membership",
    "pleaseLogin": "Please login to view membership information",
    "supportedPaymentMethods": "Supported Payment Methods",
    "upgradeTo": "Upgrade to",
    "upgradeToUnlock": "Upgrade to unlock more features",
    "usageInfo": "Usage Information",
    "validUntil": "Valid Until",
    "yearly": "Yearly",
    "subscriptionType": {
      "none": "Non-member",
      "basic": "Basic",
      "pro": "Pro",
      "business": "Business",
      "unknown": "Unknown"
    },
    "saveMoney": "Save",
    "features": {
      "aiGeneratedContent": "AI generated content",
      "voiceovers": "Voiceovers",
      "basicEditingTools": "Basic editing tools",
      "emailSupport": "Email support",
      "storage": "Storage",
      "taskHistories": "Task Histories"
    },
    "descriptions": {
      "basic": "For hobbyists",
      "pro": "Most popular",
      "business": "For professionals"
    }
  },
  "navigation": {
    "home": "Home",
    "getStarted": "Get Started",
    "production": "Workflows",
    "makeLongVideo": "Instant Reel",
    "canvasWorkflow": "Flow Canvas",
    "editVideo": "Edit Video",
    "tools": "Tools",
    "imageGeneration": "Image Generation",
    "videoGeneration": "Video Generation",
    "history": "Histories",
    "videoTasks": "Instant Reel",
    "settings": "Settings",
    "billing": "Billing",
    "loginTest": "Login Test"
  },
  "settings": {
    "settings1": "Settings",
    "underDevelopment": "This feature is under development"
  },
  "signup": {
    "alreadyHaveAccount": "Already have an account?",
    "and": "and",
    "byContinuing": "By continuing, you agree to our",
    "confirmPassword": "Confirm Password",
    "createAccount": "Create Account",
    "creatingAccount": "Creating account...",
    "email": "Email",
    "error": {
      "invalidEmail": "Invalid email format",
      "passwordMismatch": "Passwords do not match",
      "passwordTooShort": "Password must be at least 6 characters"
    },
    "fullName": "Full Name",
    "google": "Google",
    "login": "Login",
    "orContinueWith": "Or continue with",
    "password": "Password",
    "privacyPolicy": "Privacy Policy",
    "signup": "Sign Up",
    "successMessage": "Account created successfully!",
    "termsOfService": "Terms of Service"
  },
  "videoEdit": {
    "addScene": "Add Scene",
    "clickToEditTitle": "Click to edit video title",
    "clickToGenerateImage": "Click to Generate Image",
    "composite": "Composite",
    "compositeVideo": "Composite Video",
    "deleteScene": "Delete Scene",
    "addNewScene": "Add New Scene",
    "editTitle": "Edit Video Title",
    "enterVideoTitle": "Enter video title",
    "export": "Export",
    "exportMaterial": "Export Material",
    "exportMaterials": "Export Materials",
    "image": "Image",
    "loading": "Loading...",
    "materials": "Materials",
    "narration": "Narration",
    "convertVideo": "Convert Video",
    "deleteVideo": "Delete Video",
    "noScenesError": "Please add at least one scene",
    "noTitleError": "Please enter a video title",
    "emptyFrameError": "Detected empty frames or missing scenes. Please ensure all scenes have images or video content.",
    "noSceneDataError": "No scene data available. Please generate scene content first.",
    "sceneCount": "Scene {{count}}",
    "scenePreview": "Scene Preview",
    "untitledVideo": "Untitled Video",
    "submittingTask": "Submitting task...",
    "subtitle": "Subtitle",
    "taskId": "Task ID",
    "taskSubmittedError": "Failed to submit task",
    "taskSubmittedSuccess": "Task submitted successfully",
    "taskSubmittedSuccessWithEmail": "Task submitted successfully! Please check your email.",
    "title": "Title",
    "video": "Video",
    "videoTitle": "Video Title",
    "waitForAI": "Please wait for AI to generate content",
    "waitForAIGeneration": "Please wait for AI generation or load from history",
    "transitionSetting": "Transition Setting",
    "lastSceneNoTransition": "Cannot set transition for the last scene",
    "onlySceneNoTransition": "Cannot set transition with only one scene",
    "transitionType": "Transition Type",
    "transitionDuration": "Transition Duration",
    "transitionEasing": "Transition Easing",
    "transitionPreview": "Transition Preview",
    "previewArea": "Preview Area",
    "generatingVideo": "Generating Video...",
    "endTime": "End Time",
    "backgroundMusic": "Background Music",
    "sceneImage": "Scene {{sceneId}} Image {{imageId}}"
  },
  "videoGeneration": {
    "title": "Video Generation",
    "underDevelopment": "This feature is under development"
  },
  "dialog": {
    "textToImage": {
      "title": "#{{sceneNumber}} - Detailed Prompt",
      "promptLabel": "Prompt Content",
      "promptPlaceholder": "Please enter the image generation prompt...",
      "referenceImages": "Reference Images",
      "referenceImagesLabel": "Reference these images",
      "selectedReferenceImages": "{{count}} reference images selected",
      "noReferenceImages": "No reference images available",
      "referenceImagesInstruction": "Click to select reference images (multiple selection supported)",
      "qualityLabel": "Quality",
      "resolutionLabel": "Resolution",
      "imageCountLabel": "Number of Images",
      "previewLabel": "Image Preview",
      "useThisImage": "Use This Image",
      "generating": "Generating...",
      "imagePlaceholder": "Image {{index}}"
    },
    "imageToVideo": {
      "title": "#{{sceneNumber}} - Image to Video",
      "videoDescription": "Video Description",
      "descriptionPlaceholder": "Enter video description...",
      "contextImages": "Context Images",
      "contextImagesLabel": "Context images (click to select, single selection supported)",
      "selectedImages": "Selected Images and Role Configuration",
      "videoParams": "Video Parameter Configuration",
      "durationLabel": "Duration (seconds)",
      "aspectRatioLabel": "Aspect Ratio",
      "resolutionLabel": "Resolution",
      "fpsLabel": "FPS",
      "cameraMovementLabel": "Camera Movement",
      "cameraMovement": {
        "static": "Static",
        "pan": "Pan",
        "zoom": "Zoom",
        "rotate": "Rotate"
      },
      "videoStyleLabel": "Video Style",
      "videoStyle": {
        "cinematic": "Cinematic",
        "animated": "Animated",
        "realistic": "Realistic"
      },
      "addWatermark": "Add Watermark",
      "firstFrame": "First Frame",
      "lastFrame": "Last Frame",
      "referenceImage": "Reference Image",
      "delete": "Delete",
      "generating": "Generating...",
      "generateVideo": "Generate Video"
    },
    "voiceSynthesis": {
      "title": "#{{sceneNumber}} - Narration Content",
      "voiceText": "Narration Content",
      "textPlaceholder": "Enter narration content...",
      "generateVoice": "Generate Voice",
      "currentVoice": "Current Voice",
      "audioFormat": "Audio Format",
      "speechRate": "Speech Rate",
      "standard": "Standard",
      "emotion": "Emotion",
      "neutral": "Neutral"
    },
    "imageSelection": {
      "title": "#{{sceneNumber}} - Image {{imageId}}",
      "imageInfo": "Image Info",
      "sceneId": "Scene ID",
      "imageId": "Image ID",
      "imageDescription": "Image Description",
      "noDescription": "No description",
      "prompt": "Generation Prompt",
      "noPrompt": "No prompt",
      "imagePreview": "Image Preview",
      "imagePlaceholder": "Image {{imageId}}",
      "imageStatus": "Image Status",
      "imageGenerated": "Image generated",
      "imageGenerating": "Image generating...",
      "sceneNotFound": "Scene not found",
      "tip": "Tip: Return to the main interface and click \"Prompt\" to regenerate the image"
    }
  },
  "toast": {
    "voice": {
      "regenerateSuccess": "Voice regenerated successfully!",
      "regenerateError": "Failed to regenerate voice",
      "generatingVoice": "Regenerating voice...\nParams:\nText: {{text}}...\nVoice: {{voice}}\nFormat: {{format}}"
    },
    "imageToVideo": {
      "selectAtLeastOneImage": "Please select at least one image",
      "enterVideoDescription": "Please enter video description",
      "taskSubmitted": "Video generation task submitted, Task ID: {{taskId}}",
      "generationFailed": "Video generation failed, please try again later"
    },
    "video": {
      "generationSuccess": "Video generated successfully!",
      "generationFailed": "Video generation failed: {{error}}",
      "loadHistoryFailed": "Failed to load history project: {{error}}",
      "exportSuccess": "Export successful!",
      "exportFailed": "Export failed: {{error}}"
    },
    "textToImage": {
      "generationSuccess": "Image generated successfully!",
      "generationFailed": "Image generation failed",
      "imageReplaced": "Image {{index}} has been used to replace the first image of the current scene"
    },
    "membership": {
      "paymentSuccess": "Payment successful!",
      "paymentFailed": "Payment failed, please try again",
      "subscriptionCreated": "Subscription created successfully!",
      "subscriptionFailed": "Failed to create subscription, please try again",
      "upgradeSuccess": "Upgrade successful!",
      "upgradeFailed": "Upgrade failed, please try again",
      "alreadyOnPlan": "You are already on this plan",
      "switchedToBasic": "Switched to Basic Plan",
      "popupClosedRefreshing": "PayPal payment page closed, refreshing to update payment status...",
      "redirectedToPayPal": "Successfully redirected to PayPal payment page, please complete payment in the popup window",
      "redirectedToPayPalNewTab": "Redirected to PayPal payment page, please complete payment in the new tab"
    },
    "common": {
      "unknownError": "An unknown error occurred",
      "processing": "Processing...",
      "success": "Success!",
      "error": "Error!"
    }
  },
  "errorBoundary": {
    "componentFailed": "Component failed to load",
    "unknownError": "An unknown error occurred"
  },
  "tutorial": {
    "title": "🎬 Start generating your video",
    "description": "Describe your video idea in the input box below, and AI will automatically generate a storyboard script for you",
    "example": "Example: \"Help me generate a sci-fi short video script about space exploration, including 3 scenes\"",
    "howCreate": "How to Create AI Videos for Social Platforms: Youtube, TikTok, etc.",
    "step1": {
      "title": "Input Your Concept",
      "englishTitle": "Input Concept",
      "items": [
        "Set core theme",
        "Choose narration voice style",
        "Define resolution (9:16 / 16:9)"
      ]
    },
    "step2": {
      "title": "AI Storyboard Generation",
      "englishTitle": "AI Generation",
      "items": [
        "Intelligently enrich themes and generate storyboard prompts",
        "AI automatically generates high-quality images",
        "TTS engine automatically synthesizes narration audio",
        "Automatically aligns duration with audio rhythm"
      ]
    },
    "step3": {
      "title": "Edit and Fine-tune Your Scenes",
      "englishTitle": "Fine-tuning",
      "items": [
        "Edit prompts to generate new images (img2img)",
        "One-click image-to-video conversion (Motion)",
        "Add scene transition effects",
        "Intelligently adjusts video clip duration"
      ]
    },
    "step4": {
      "title": "Synthesize Final Video",
      "englishTitle": "Final Synthesis",
      "items": [
        "Multi-modal synthesis (image/video/audio/text)",
        "Apply cinematic transition effects",
        "Export videos optimized for social platforms"
      ]
    }
  },
  "transition": {
    "fade": "Fade",
    "dissolve": "Dissolve",
    "wipe": "Wipe",
    "slide": "Slide",
    "push": "Push",
    "circlecrop": "Circle Crop",
    "rectcrop": "Rectangle Crop",
    "left": "Left",
    "right": "Right",
    "up": "Up",
    "down": "Down",
    "linear": "Linear",
    "in": "Ease In",
    "out": "Ease Out",
    "inOut": "Ease In/Out"
  },
  "feedback": {
    "title": "User Feedback",
    "titleLabel": "Feedback Title",
    "titlePlaceholder": "Please enter feedback title",
    "titleRequired": "Feedback title is required",
    "titleTooLong": "Feedback title cannot exceed 100 characters",
    "contentLabel": "Feedback Content",
    "contentPlaceholder": "Please describe your issue or suggestion in detail...",
    "contentRequired": "Feedback content is required",
    "contentTooLong": "Feedback content cannot exceed 1000 characters",
    "emailLabel": "Email",
    "emailPlaceholder": "Please enter your email",
    "emailRequired": "Email is required",
    "invalidEmail": "Invalid email format",
    "submit": "Submit Feedback",
    "submitSuccess": "Feedback submitted successfully! Thank you for your feedback.",
    "networkError": "Network error, please check your network connection"
  },
  "videoPlayer": {
    "preparing": "Preparing...",
    "allScenesCompleted": "All scenes completed",
    "play": "Play",
    "pause": "Pause"
  },
  "pricing": {
    "title": "AI Service Pricing",
    "subtitle": "View our AI service pricing and credits consumption",
    "credits": "Credits",
    "benefitType": "Benefit Type",
    "fetchError": "Failed to fetch service configuration",
    "noServices": "No services available",
    "services": {
      "chat": "AI Chat Service",
      "image": "Image Generation Service",
      "video": "Video Generation Service",
      "tts": "Text-to-Speech Service"
    },
    "faq": {
      "title": "FAQ",
      "whatAreCredits": "What are credits?",
      "creditsDescription": "Credits are the virtual currency used in our platform to pay for AI services.",
      "howToPurchase": "How to purchase credits?",
      "purchaseDescription": "You can purchase credits through our membership plans or directly in the credits store.",
      "creditsExpire": "Do credits expire?",
      "expireDescription": "The monthly credits quota expires with your membership cycle. Unused credits will not roll over to the next month."
    }
  },
  "videoEditPage": {
    "description": "Description",
    "narration": "Narration",
    "prompt": "Prompt",
    "playAudio": "Play Audio",
    "pauseAudio": "Pause Audio",
    "clickToGenerateImage": "Click to Generate Image"
  },
  "videoEditorSimple": {
    "title": "Vissynth",
    "subtitle": "Video Editor",
    "uploadVideo": "Click to upload video",
    "videoSettings": "Video Settings",
    "resolution": "Resolution",
    "frameRate": "Frame Rate",
    "duration": "Duration",
    "text": "Text",
    "backgroundMusic": "Background Music"
  },
  "canvas": {
    "uploadImage": {
      "noImage": "No Image",
      "upload": "Upload",
      "unsupportedFormat": "Unsupported image format. Only JPEG/JPG, PNG, GIF, WebP are supported",
      "fileTooLarge": "Single image cannot exceed 10 MB"
    },
    "templates": {
      "dialog": {
        "title": "Workflow Templates",
        "categories": "Categories",
        "noCategories": "No category data",
        "templateList": "Template List",
        "noCategoryData": "Please get category data first",
        "noTemplates": "No templates in current category",
        "preview": "Template Preview",
        "workflowSnippet": "Workflow Snippet:",
        "nodes": "nodes",
        "edges": "connections",
        "withViewport": "With viewport config",
        "use": "Use"
      }
    },
    "controlPanel": {
      "templates": {
        "title": "Workflow Templates",
        "button": "Templates"
      }
    },
    "controls": {
      "zoomIn": "Zoom In",
      "zoomOut": "Zoom Out",
      "fitView": "Fit View",
      "autoLayout": "Auto Layout"
    },
    "dynamicPrompt": {
      "advancedMode": "Advanced Mode",
      "template": "Template",
      "outputPrompt": "Output Prompt",
      "noInputFields": "No input fields available"
    }
  },
  "accountInfo": {
    "title": "Account Information",
    "underDevelopment": "Account information feature is under development, coming soon..."
  },
  "subtitle": {
    "configTitle": "Subtitle Style Configuration",
    "selectTemplate": "Select Template",
    "customStyle": "Custom Style",
    "preview": "Preview",
    "livePreview": "Live Preview",
    "previewText": "This is a subtitle preview text",
    "templatePreview": "Subtitle Preview",
    "fontSettings": "Font Settings",
    "fontSize": "Font Size",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "colorSettings": "Color Settings",
    "textColor": "Text Color",
    "outlineColor": "Outline Color",
    "width": "Width",
    "enableBgColor": "Enable Background Color",
    "positionSettings": "Position Settings",
    "alignment": "Alignment",
    "top": "Top",
    "center": "Center",
    "bottom": "Bottom",
    "verticalMargin": "Vertical Margin"
  }
};
